'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = async function BlobDownloader(url, fileName) {
    var response = await fetch(url);
    var blob = await response.blob();
    var blobUrl = URL.createObjectURL(blob);

    // We have to create an anchor to download the file
    var tempAnchor = document.createElement('a');
    tempAnchor.download = fileName;
    tempAnchor.href = blobUrl;
    document.body.appendChild(tempAnchor); // for firefox: https://stackoverflow.com/a/32226068
    tempAnchor.click();
    tempAnchor.remove();
};

module.exports = exports['default'];
//# sourceMappingURL=BlobDownloader.js.map